import { render, staticRenderFns } from "./editFormDialog.vue?vue&type=template&id=2a0799a8&scoped=true&lang=pug"
import script from "./editFormDialog.vue?vue&type=script&lang=js"
export * from "./editFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0799a8",
  null
  
)

export default component.exports